import axios from "../../utils/axios"

export const getAllSocialMedia = async () => {
    return await axios.get("api/allSocialMedia");
}